import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./Loading.css";

function Loading() {
  return (
    <div className="loading-container" data-testid="loading">
      <Spinner animation="border" variant="light" aria-label="Loading" />
    </div>
  );
}

export default Loading;
